export const DATA_SEARCH = "SEARCH";
export const BUKU_PROMOSI = "BUKU_PROMOSI";